import React from 'react';
import startCase from 'lodash/startCase';
import { compose } from 'recompose';
import styled, { StylesProps, cx } from '../../../../../../../lib/styles';
import articleStyles from './ArticleCard_styles';
import Spacer from '../../../../../../../components/presentational/Spacer';
import { Article } from '../../../../../../../models/article';
import StoryAuthor from '../../../../../../../components/presentational/StoryAuthor';
import Image from '../../../../../../../components/presentational/Image';

export interface ArticleProps {
  disableAuthor: boolean;
  article: Article;
  lazy?: boolean;
  onClick?: () => any;
}

const ArticleCard = ({
  onClick,
  article,
  styles,
  lazy = true,
  disableAuthor,
}: ArticleProps & StylesProps<typeof articleStyles>) => {
  return (
    <a className={`${styles.link} article-card`} href={article.link ?? '#'} onClick={onClick}>
      <Spacer space={'s'}>
        <div className={styles.featureImageContainer}>
          <Image
            alt={article.title}
            className={cx(styles.image, 'ArticleCard__image')}
            src={article.medium_image}
            lazy={lazy}
            aspect={[16, 9]}
            resizeWidth={390}
            resizeFit={'min'}
          />
        </div>
        <Spacer space={'xxs'} align={'flex-start'}>
          <span className={styles.category}>
            {startCase((article.category || '').toLowerCase())}
          </span>
          <h2 className={cx(styles.title, 'ArticleCard__title')}>
            {article.title}
          </h2>
          <span className={styles.subtitle}>{article.excerpt}</span>
          {!disableAuthor && article.author && (
            <StoryAuthor size={'s'} author={article.author} />
          )}
        </Spacer>
      </Spacer>
    </a>
  );
};

export default compose(styled(articleStyles))(ArticleCard);
